import type { CnmcApplication, CnmcPlan } from "./cnmcTypes";
import type { RegistryConnection } from "@/types";

export const hasCnmcConnection = (connections: RegistryConnection[] = []) =>
  connections.some((connection) => connection.integration_name === "CNMC");

/** Displays each reported month once, in production order. */
export const planPeriod = (plan: CnmcPlan, locale: string) =>
  [...new Set(plan.inputs.production_sources.map((source) => source.month))]
    .sort()
    .map((month) =>
      new Date(month).toLocaleDateString(locale, {
        year: "numeric",
        month: "long",
        timeZone: "UTC",
      })
    )
    .join(", ");

/** The supplied meter readings, including fractions excluded from issuance. */
export const reportedProduction = (plan: CnmcPlan) =>
  plan.inputs.production_sources.reduce(
    (sum, source) => sum + Number(source.value),
    0
  );

/** Classifies source filings separately from their downstream delivery requests. */
export const isIssuance = (application: CnmcApplication) =>
  ["DOMESTIC_ISSUANCE", "EXPORT_ISSUANCE"].includes(
    application.application_type
  );

/** Counts current issuance files, excluding retired versions. */
export const issuanceFileCount = (plan: CnmcPlan) =>
  plan.applications.filter(
    (application) =>
      isIssuance(application) &&
      !["ABANDONED", "SUPERSEDED"].includes(application.status)
  ).length;

/** A consistent status palette across batches, application cards and linked orders. */
export const statusClass = (status: string) => {
  if (status === "NEEDS_ATTENTION")
    return "bg-danger-subtle text-danger-emphasis";
  if (["COMPLETE", "COMPLETED"].includes(status))
    return "bg-success-subtle text-success-emphasis";
  if (["SUBMITTED", "PENDING", "APPROVED", "IN_PROGRESS"].includes(status))
    return "bg-warning-subtle text-warning-emphasis";
  return "bg-secondary-subtle text-body-secondary";
};
